import React, { useState, useEffect } from 'react';

import { Grid } from '@material-ui/core';

import { GradientLogin } from 'components/molecules/GradientLogin';
import { LoginForm } from 'components/organisms/LoginForm';

export function SignIn() {
  const [isScreenLarge, setIsScreenLarge] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = () => {
      setIsScreenLarge(window.innerWidth >= 815);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Grid
      container
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      <GradientLogin isScreenLarge={isScreenLarge} />
      <LoginForm isScreenLarge={isScreenLarge} />
    </Grid>
  );
}
